import { render, staticRenderFns } from "./NewsEdit.vue?vue&type=template&id=b84d8402&scoped=true"
import script from "./NewsEdit.vue?vue&type=script&lang=js"
export * from "./NewsEdit.vue?vue&type=script&lang=js"
import style0 from "./NewsEdit.vue?vue&type=style&index=0&id=b84d8402&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84d8402",
  null
  
)

export default component.exports